import { Matrix } from 'app/models/questions/Matrix'
import { QuestionComponent } from 'app/models/questions/QuestionComponent'
import { PhoneComponent } from 'app/modules/survey/survey-viewer/survey-question/types/phone/phone.component'
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms'
import { requireCommentOnOpenSelection } from 'app/form-validators/RequireCommentOnOpenSelectionValidator'
import { phoneValidator } from 'app/form-validators/PhoneValidator'

export class Phone extends Matrix {
  private readonly _phoneFormControlName = 'info_phone'

  getDisplayComponent(): QuestionComponent {
    return new QuestionComponent(PhoneComponent, this)
  }

  formatFormPayload(surveyForm: UntypedFormGroup): Record<string, {}> {
    const formValues = surveyForm.get(this.key).value

    if (formValues[this.rowKeys[this.rowKeys.length - 1]][this.commentsControlName][this.phoneFormControlName]) {
      formValues[this.rowKeys[this.rowKeys.length - 1]][this.commentsControlName][this.phoneFormControlName] = formValues[this.rowKeys[this.rowKeys.length - 1]][this.commentsControlName][this.phoneFormControlName].replace(/\D/g,'')
    }

    return formValues
  }

  buildQuestionFormGroup(): UntypedFormGroup {
    const formGroup = new UntypedFormGroup({})

    this.rowsOrder.forEach(rKey => {
      const validators = this.isOptional ? [] : [requireCommentOnOpenSelection(this.formControlName, this.commentsControlName, this.getOpenStatementsForRow(rKey))]
      const statementFormGroup = new UntypedFormGroup({
        [this.formControlName]: this.buildPhoneStatementFormGroup(),
        [this.commentsControlName]: this.buildPhoneCommentFormGroup()
      }, validators)
      formGroup.addControl(rKey, statementFormGroup)
    })

    return formGroup
  }

  fillFormWithDummyAnswer(surveyForm) {
    this.resetForm(surveyForm)

    this.setEverySelectedControlToTrueForGivenRow(surveyForm, this.rowKeys[this.rowKeys.length - 1])
    this.buildRandomValidAnswer(surveyForm)
  }

  private buildPhoneStatementFormGroup(): UntypedFormGroup {
    const form = new UntypedFormGroup({})
    this.statementKeys.forEach(sKey => {
      form.addControl(sKey, new UntypedFormControl(true))
    })
    return form
  }

  resetForm(surveyForm: UntypedFormGroup) {
    surveyForm.enable({emitEvent: false})

    const emptyMatrixAnswers = {}

    this.rowKeys.forEach(rKey => {
      if (!emptyMatrixAnswers[rKey]) {
        emptyMatrixAnswers[rKey] = {}
        emptyMatrixAnswers[rKey][this.formControlName] = {}
        emptyMatrixAnswers[rKey][this.commentsControlName] = {}
      }
      this.statementKeys.forEach(sKey => {
        emptyMatrixAnswers[rKey][this.formControlName][sKey] = false
        emptyMatrixAnswers[rKey][this.commentsControlName][sKey] = ''
      })
    })

    surveyForm.controls[this.key].reset(emptyMatrixAnswers, {emitEvent: false})
  }

  private buildPhoneCommentFormGroup(): UntypedFormGroup {
    const form = new UntypedFormGroup({})
    this.statementKeys.forEach(sKey => {
      form.addControl(sKey, new UntypedFormControl('', phoneValidator(this.isOptional)))
    })
    return form
  }

  private buildRandomValidAnswer(surveyForm) {
    const validAnswer = Math.random().toString().slice(2, 5) + '-' + Math.random().toString().slice(2, 5) + '-' + Math.random().toString().slice(2, 6)
    surveyForm.controls[this.key].get(this.rowKeys.pop()).get(this.commentsControlName).get(this.phoneFormControlName).setValue(validAnswer, {emitEvent: false})
  }

  get phoneFormControlName() {
    return this._phoneFormControlName
  }
}
